import {
  ERROR_VALIDATION_PAYMENTS_ALREADY_MADE,
  ERROR_VALIDATION_TOKEN_DUPLICATE,
  ERROR_VALIDATION_TOKEN_MAX_COUNT,
  ERROR_VALIDATION_TOO_CLOSE_TO_DELIVERY,
  ERROR_VALIDATION_TOO_CLOSE_TO_PICKUP,
  ERROR_VALIDATION_UPDATE_BAD_STATUS,
} from '@/constants/errorCodes'

const supportedErrorCodes = {
  // ConfirmationHome
  [ERROR_VALIDATION_UPDATE_BAD_STATUS]: {
    text: 'Order can no longer be changed in the application.',
    subText: 'Please contact customer support.',
  },
  [ERROR_VALIDATION_PAYMENTS_ALREADY_MADE]: {
    text: 'Order has already been paid and cannot be changed.',
    subText: 'Please contact customer support.',
  },
  [ERROR_VALIDATION_TOO_CLOSE_TO_DELIVERY]: {
    text: 'Order is less than 24 hours from delivery and cannot be changed.',
    subText: 'Please contact customer support.',
  },
  [ERROR_VALIDATION_TOO_CLOSE_TO_PICKUP]: {
    text: 'Order is less than 12 hours from pickup and cannot be changed.',
    subText: 'Please contact customer support.',
  },

  // Payment
  [ERROR_VALIDATION_TOKEN_MAX_COUNT]: {
    text: 'Cannot save more than 2 credit or debit cards.',
  },
  [ERROR_VALIDATION_TOKEN_DUPLICATE]: {
    text: 'Looks like this card is already saved.',
    subText: 'Please try a different one.',
  },
}

export function getErrorMessageString(error, subTextSeparator = ' ') {
  const errorObject = getErrorMessage(error)

  return (
    (errorObject &&
      errorObject.text +
        (errorObject.subText && subTextSeparator + errorObject.subText)) ||
    ''
  )
}

export function getErrorMessage(error) {
  const errorCode =
    error &&
    ((error.validationErrors &&
      error.validationErrors.length &&
      error.validationErrors[0].errorCode) ||
      error.errorCode)

  return (
    supportedErrorCodes[errorCode] || supportedErrorCodes['COO-' + errorCode]
  )
}
